import { createRequestTypes } from '../utils';

export const PROCESS = createRequestTypes('process/PROCESS');
export const SAVE_PROCESS = createRequestTypes('process/SAVE_PROCESS');
export const DELETE_PROCESS = createRequestTypes('process/DELETE_PROCESS');
export const ADD_PROCESS = createRequestTypes('process/ADD_PROCESS');
export const ADD_MULTIPLE_PROCESSES = createRequestTypes('process/ADD_MULTIPLE_PROCESSES');
